<template>
  <UiComponentWrapper
    class="select"
    :style="style"
  >
    <UiComponentWrapper
      v-for="(option, i) in options"
      :key="`option-${i}`"
      class="option"
      :class="{ active: index === i }"
      @click="setIndex(i)"
    >
      {{ option }}
    </UiComponentWrapper>
  </UiComponentWrapper>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'change',
])

// Props
const props = defineProps({
  options: {
    default() {
      return []
    },
    required: false,
    type: Array,
  },
  value: {
    default() {
      return 0
    },
    required: false,
    type: Number,
  },
})

// Refs
const index = ref(props.value)

// Computed Properties
const style = computed(() => {
  return {
    '--length': props.options.length,
    '--transform': `translateX(${(index.value * 100)}%)`,
  }
})

// Methods
function setIndex(value) {
  if (value === index.value) {
    return
  }

  index.value = value
  emit('change', value)
}
</script>

<style lang="postcss" scoped>
.select {
  @apply relative mt-1 p-1 bg-livestorm-blue-100 rounded;

  &::before {
    @apply absolute left-1 top-1 h-10 bg-white border border-livestorm-blue-200 rounded-xs shadow-light1 content-[''] z-0 transition-transform duration-600 ease-in-out;
    transform: var(--transform);
    width: calc((100% - 8px) / var(--length));
  }

  .option {
    @apply justify-center px-3 py-2 font-medium text-grey-blue-600 text-sm leading-6 cursor-pointer z-10 transition-colors duration-600 ease-in-out;

    &.active {
      @apply text-livestorm-blue-700 cursor-default;
    }
  }
}
</style>
